export enum EnumPartnerSegmentPortfolio {
  COMMERCE = "Comércio",
  CONSTRUCTION = "Construção",
  INDUSTRY = "Indústria",
  TECHNOLOGY = "Tecnologia",
  FINANCIAL_SERVICES = "Serviços Financeiros",
  OTHERS = "Outros",
}
